var map = {
	"./scripts/patterns/CreateNotificationModal.vue": 702,
	"./scripts/patterns/FilterDropdown.vue": 1133,
	"./scripts/patterns/NavBar.vue": 1138,
	"./scripts/patterns/NotificationContentModal.vue": 473,
	"./scripts/patterns/PermissionSelector.vue": 1139,
	"./scripts/patterns/ResourceCard/ResourceCard.vue": 1140,
	"./scripts/patterns/ResourceCard/ResourceDescriptionModal.vue": 706,
	"./scripts/patterns/ResourceCard/ResourceModal.vue": 474,
	"./scripts/patterns/ResourceCard/ResourceSharedWithSideDrawer.vue": 705,
	"./scripts/patterns/SideNav.vue": 1141,
	"./scripts/patterns/SubmitFeedbackModal.vue": 704,
	"./scripts/patterns/ViewNotificationModal.vue": 45
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1132;